module.exports = __webpack_public_path__ + "static/meltiom450-d1a1b4648419bdfbac3744b5174c08ef.png";